<template>
  <div class="cont">
    <van-form
      @submit="onSubmit"
      validate-trigger="onSubmit"
      :show-error="false"
    >
      <!-- 发票类型 -->
      <div class="genre">
        <p
          style="margin-top: 0.2667rem;font-weight:600; color:#333333;font-size:0.3733rem;padding-left:0.4267rem"
          class="title"
        >
          发票类型
        </p>
        <van-field v-model="radioParam" name="radioParam">
          <template #input>
            <div class="RadioStyle">
              <div class="radioList" @change="getinfo(radioParam)">
                <input
                  type="radio"
                  name="Storage"
                  id="Radio1"
                  value="1"
                  v-model="radioParam"
                />
                <label for="Radio1">纸质普通发票</label>
                <input
                  type="radio"
                  name="Storage"
                  id="Radio2"
                  value="2"
                  v-model="radioParam"
                />
                <label for="Radio2">增值税专用发票</label>
              </div>
            </div>
          </template>
        </van-field>
      </div>
      <!-- 发票抬头 -->
      <div class="genre">
        <p
          class="title"
          style="margin-top: 0.2667rem;font-weight:600; color:#333333;font-size:0.3733rem;padding-left:0.4267rem"
        >
          发票抬头
        </p>
        <van-field v-model="rise" name="rise">
          <template #input>
            <div class="RadioStyle">
              <div class="radioList" @change="getRise(rise)">
                <input
                  type="radio"
                  name="Storage1"
                  id="Radio3"
                  value="3"
                  v-model="rise"
                />
                <label v-if="radioParam == '1'" for="Radio3">个人</label>
                <input
                  type="radio"
                  name="Storage1"
                  id="Radio4"
                  value="4"
                  v-model="rise"
                />
                <label for="Radio4">单位</label>
              </div>
            </div>
          </template>
        </van-field>
      </div>
      <!-- 抬头名称 -->
      <van-field
        v-model="username"
        name="username"
        label="抬头名称"
        :placeholder="
          invoiceType == '1' ? '请输入个人或姓名' : '请输入单位名称'
        "
        :rules="[
          { required: true, message: '请输入个人或单位名称' },
          {
            pattern: /^[A-Za-z0-9-\(\)\u4e00-\u9fa5\（\）]{1,64}$/,
            message: '抬头有误',
          },
        ]"
      />
      <!-- 纳税人识别号 -->
      <van-field
        v-if="rise == '4'"
        v-model="taxpayer"
        name="taxpayer"
        label="纳税人识别号"
        placeholder="或社会统一信用代码"
        format-trigger="onBlur"
        :rules="[
          { required: true, message: '请输入纳税人识别号或社会统一信用代码' },
          {
            pattern: /^[A-Z0-9]{15}$|^[A-Z0-9]{18}$|^[A-Z0-9]{20}$/,
            message: '纳税人识别号位数或格式有误',
          },
        ]"
      />
      <!-- 注册地址 -->
      <van-field
        v-if="radioParam == '2'"
        v-model="registered"
        name="registered"
        label="注册地址"
        placeholder="请确保与贵司税务登记地址一致"
        :rules="[
          { required: true, message: '请输入注册地址' },
          {
            pattern: /^[A-Za-z0-9-\(\)\u4e00-\u9fa5\（\）]{1,64}$/,
            message: '注册地址有误',
          },
        ]"
      />
      <!-- 注册电话 -->
      <van-field
        v-if="radioParam == '2'"
        v-model="phone"
        name="phone"
        label="注册电话"
        :rules="[
          { required: true, message: '请输入注册电话' },
          {
            pattern: /^((0\d{2,3}-\d{7,8})|(1[3456789]\d{9}))$/,
            message: '请输入正确的手机号',
          },
        ]"
      />
      <!-- 开户银行 -->
      <van-field
        v-if="radioParam == '2'"
        v-model="deposit"
        name="deposit"
        label="开户银行"
        :rules="[
          { required: true, message: '请输入开户银行' },
          {
            pattern: /^[A-Za-z0-9-\(\)\u4e00-\u9fa5\（\）]{1,64}$/,
            message: '开户银行有误',
          },
        ]"
      />
      <!-- 银行账户 -->
      <van-field
        v-if="radioParam == '2'"
        v-model="account"
        type="number"
        name="account"
        label="银行账户"
        :rules="[
          { required: true, message: '请输入银行账号' },
          {
            pattern: /^\d{1,64}$/,
            message: '开户银行有误',
          },
        ]"
      />
      <!-- 发票内容 -->
      <van-field label="发票内容" value="明细" readonly />
      <!-- 发票金额 -->
      <van-field v-model="money" name="发票金额" label="发票金额" readonly />
      <!-- 收票人 -->
      <van-field
        v-if="radioParam == '2'"
        v-model="ticket"
        name="ticket"
        label="收票人"
        placeholder="请填写收票人姓名"
        :rules="[
          { required: true, message: '收票人不能为空' },
          {
            pattern: /^[A-Za-z0-9-\(\)\u4e00-\u9fa5\（\）]{1,64}$/,
            message: '收票人有误',
          },
        ]"
      />
      <!-- 手机号 -->
      <van-field
        v-if="radioParam == '2'"
        v-model="Mobile"
        type="digit"
        name="Mobile"
        label="手机号"
        placeholder="请填写收票人手机号码"
        @focus="inputFocus"
        :rules="[
          { required: true, message: '请填写手机号' },
          {
            pattern: /^(1[3456789]\d{9})$/,
            message: '请输入正确的手机号',
          },
        ]"
      />
      <!-- 所在地区 -->
      <van-field
        v-if="radioParam == '2'"
        v-model="fieldValue"
        is-link
        readonly
        label="地区"
        placeholder="请选择所在地区"
        @click="show = true"
        :rules="[{ required: true, message: '请选择地址' }]"
      />
      <van-popup v-model="show" round position="bottom">
        <van-cascader
          v-model="cascaderValue"
          title="请选择所在地区"
          :options="options"
          @change="onChange"
          @close="show = false"
          @finish="onFinish"
        />
      </van-popup>
      <!-- 详细地址 -->
      <van-field
        v-if="radioParam == '2'"
        v-model="address"
        name="address"
        label="详细地址"
        placeholder="如道路、门牌号、小区、楼栋号、单元室等"
        :rules="[
          { required: true, message: '详细地址不能为空' },
          {
            pattern: /^[A-Za-z0-9-\(\)\u4e00-\u9fa5\（\）]{1,64}$/,
            message: '详细地址有误',
          },
        ]"
      />
      <div style="margin: 16px;">
        <van-button round block type="info" color="#fc563a" native-type="submit"
          >申请开票</van-button
        >
      </div>
    </van-form>
  </div>
</template>

<script>
export default {
  name: "invoice",
  props: ["money","recordCode2"],
  data() {
    return {
      show: false,
      fieldValue: "", //地址
      cascaderValue: "",
      radioParam: "1", //发票类型
      rise: "3", //发票抬头
      username: "", //抬头名称
      taxpayer: "", //纳税人识别号
      registered: "", // 注册地址
      phone: "", //注册电话
      deposit: "", //开户银行
      account: "", //银行账户
      ticket: "", //收票人
      Mobile: "", //手机号
      address: "", //详细地址
      options: [],
      province: "",
      city: "",
      county: "",
      street: "",
      invoiceType: "1",
    };
  },
  created() {
    this.getProvince();
  },
  methods: {
    getAdders() {
      this.show = true;
      this.$post({
        url: "/baseArea/listBaseArea",
        method: "get",
      }).then((res) => {
        if (res.retCode == 200) {
          res.data.code.forEach((item) => {
            return this.options.push([
              {
                text: item.name,
                value: item.id,
                children: [],
              },
            ]);
          });
        } else {
          this.$toast("获取地址信息失败");
        }
      });
    },
    // 全部选项选择完毕后，会触发 finish 事件
    onFinish({ selectedOptions }) {
      this.show = false;
      this.province = selectedOptions[0].value;
      this.city = selectedOptions[1].value;
      this.county = selectedOptions[2].value;
      if (selectedOptions.length == 4) {
        this.street = selectedOptions[3].value;
      } else {
        this.street = "";
      }
      this.fieldValue = selectedOptions.map((option) => option.text).join("/");
    },
    // 点击获取市、区、镇级数据
    onChange({ value }) {
      this.$post({
        url: "/baseArea/listBaseArea",
        method: "get",
        params: {
          parentId: value,
        },
      }).then((res) => {
        if (res.retCode == 200) {
          if (res.data.code.length == 0) {
            return false;
          } else {
            // 市级数据
            if (res.data.code[0].level == 2) {
              this.options.forEach((element) => {
                element.children = [];
              });
              res.data.code.forEach((item) => {
                this.options.forEach((element) => {
                  if (element.value == item.parent_id) {
                    element.children.push({
                      text: item.name,
                      value: item.id,
                      children: [],
                    });
                  }
                });
              });
              // 区/县级数据
            } else if (res.data.code[0].level == 3) {
              this.options.forEach((element) => {
                element.children.forEach((element2) => {
                  element2.children = [];
                });
              });
              res.data.code.forEach((item) => {
                this.options.forEach((element) => {
                  element.children.forEach((element2) => {
                    if (element2.value == item.parent_id) {
                      if (item.childCount == 0) {
                        element2.children.push({
                          text: item.name,
                          value: item.id,
                        });
                      } else {
                        element2.children.push({
                          text: item.name,
                          value: item.id,
                          children: [],
                        });
                      }
                    }
                  });
                });
              });
              // 镇/街道级数据
            } else if (res.data.code[0].level == 4) {
              this.options.forEach((element) => {
                element.children.forEach((element2) => {
                  element2.children.forEach((element3) => {
                    element3.children = [];
                  });
                });
              });
              res.data.code.forEach((item) => {
                this.options.forEach((element) => {
                  element.children.forEach((element2) => {
                    element2.children.forEach((element3) => {
                      element3.children.push({
                        text: item.name,
                        value: item.id,
                      });
                    });
                  });
                });
              });
            }
          }
        } else {
          this.$toast("获取地址信息失败");
        }
      });
    },
    // 获取省级数据
    getProvince() {
      this.$post({
        url: "/baseArea/listBaseArea",
        method: "get",
      }).then((res) => {
        if (res.retCode == 200) {
          res.data.code.forEach((item) => {
            return this.options.push([
              {
                text: item.name,
                value: item.id,
                children: [],
              },
            ]);
          });
          this.options = [].concat(...this.options);
        } else {
          this.$toast("获取地址信息失败");
        }
      });
    },
    //发票类型
    getinfo(value) {
      if (value == "2") {
        this.rise = "4";
        this.invoiceType = "3";
      }
    },
    getRise(value) {
      if (value == "3") {
        this.invoiceType = "1";
      } else {
        this.invoiceType = "2";
      }
    },
    // 提交发票
    onSubmit(values) {
      let invoiceValues = "";
      if (values.radioParam == "1" && values.rise == "3") {
        invoiceValues = "1";
      } else if (values.radioParam == "1" && values.rise == "4") {
        invoiceValues = "2";
      } else if (values.radioParam == "2") {
        invoiceValues = "3";
      }
     
      this.$post({
        url: "/invoice/addInvoice",
        method: "post",
        data: {
          // userId: sessionStorage.getItem("EXCLUSIVE"),
          invoiceType: invoiceValues, //发票类型
          invoiceHeader: this.username, //发票抬头（选择）
          payeeName: this.ticket, //收票人名称
          taxId: this.taxpayer, //纳税人识别号
          companyAddress: this.registered, //注册地址
          companyPhone: this.phone, //注册电话
          depositaryBank: this.deposit, //开户银行
          bankNum: this.account, //银行账户
          mobilePhone: this.Mobile, //手机号码
          billingAddress: this.address, //详细地址
          province: this.province, //地址（省）
          city: this.city, //地址（市）
          district: this.county, //地址（县）
          street: this.street, //地址（镇）
          invoiceName: "纸质发票",
          invoiceContent: "明细",
          recordCode: this.recordCode2,//订单号
          firstChoice: 0,
        },
      })
        .then((res) => {
          this.$emit(
            "chengeSubmit",
            false,
            invoiceValues,
            this.ticket,
            res.data.invoiceId
          );
        })
        .catch((err) => {
          console.log(err);
        });
    },
    inputFocus() {
    },
  },
};
</script>
<style lang="less" scoped>
.cont {
  // height: 14rem;
  background-color: white;
  .genre {
    .title {
      font-size: 0.3733rem;
      font-weight: 500;
      color: #333;
    }
    .RadioStyle input {
      line-height: 0.8rem;
      height: 0.8rem;
      border-radius: 0.0533rem;
      display: none;
    }
    .RadioStyle label {
      border: 1px solid rgb(175, 175, 175);
      line-height: 0.8rem;
      height: 0.8rem;
      font-size: 0.32rem;
      padding: 0px 0.4333rem;
      float: left;
      border-radius: 3rem;
      margin: 0.1333rem 0.2133rem;
      text-align: center;
    }
    .RadioStyle input:checked + label {
      border: 1px solid #fc563a;
      color: #fc563a;
    }
  }
  /deep/.van-cell__title {
    span {
      color: #333;
      font-weight: 600;
    }
  }
}
</style>
